// extracted by mini-css-extract-plugin
export default {"poll-modal":"Form_poll-modal__JKbSR","form":"Form_form__psS5c","section-wrapper":"Form_section-wrapper__tpJPZ"};